module.exports = __webpack_public_path__ + "static/logo-d2acc67bc0467beca56a78100fcca057.svg";